import Postal from 'postal';

export default class EventTarget {
  constructor(channelName) {
    this.channelName = channelName || `${new Date().getTime()}_channel`;
    this.channel = Postal.channel(channelName);
    this.topicMap = {};
  }

  subEvent(eventType, scope, func) {
    this.topicMap[eventType] = this.channel.subscribe(eventType, this.proxy(scope[func], scope));
  }

  unSubEvent(eventType) {
    if (eventType && this.topicMap[eventType]) {
      this.topicMap[eventType].unsubscribe();
    }
  }

  dispatchEvent(eventType, data) {
    this.channel.publish(eventType, data);
  }

  proxy(func, scope) {
    if (!func) {
      console.error("the func can't be null or undefined!");
      return null;
    }

    if (Object.prototype.toString.call(func) !== '[object Function]') {
      console.error('the func must be a real function!');
      return null;
    }

    return function(...rest) {
      // eslint-disable-next-line prefer-rest-params
      return func.apply(scope || this, rest);
    };
  }
}
